document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.pg-content-faq__item');

    items.forEach(item => {
        const title = item.querySelector('.pg-content-faq__item-title');

        title.addEventListener('click', () => {
            item.classList.toggle('is-open');
            title.classList.toggle('is-open');
        });
    });


    const hero = document.querySelector('.l-header');
    if (!hero) return;

    const slides = hero.querySelectorAll('.l-header__bg');
    if (!slides.length) return;

    // 初期表示
    let index = 0;
    slides[index].classList.add('is-active');

    // ユーザーの簡易アクセシビリティ配慮
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const intervalMs = prefersReduced ? 4000 : 4000; // reduce の場合はゆっくり

    setInterval(() => {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
    }, intervalMs);



    const movie = document.querySelector('.js-scroll-child');
    if (!movie) return;

    let lastState = '';
    let isEnabled = window.innerWidth > 768;
    const headerHeight = 60;

    const updatePosition = () => {
        if (!isEnabled) {
            movie.style.position = 'absolute';
            movie.style.top = '';
            //movie.style.width = '';
            movie.style.left = ''; // ← CSSに戻す
            return;
        }

        const rect = movie.getBoundingClientRect();

        // absolute
        if (rect.top > headerHeight) {
            if (lastState !== 'absolute') {
                movie.style.position = 'absolute';
                movie.style.top = '';
                //movie.style.width = '';
                movie.style.left = '';
                lastState = 'absolute';
            }
            return;
        }

        // fixed
        if (rect.top <= headerHeight) {
            requestAnimationFrame(() => {
                movie.style.position = 'fixed';
                movie.style.top = headerHeight + 'px';
                //movie.style.width = rect.width + 'px';
                movie.style.left = ''; // ★重要
            });
            lastState = 'fixed';
        }
    };

    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', () => {
        isEnabled = window.innerWidth > 768;
        updatePosition();
    });



    //-----------------------------------------------------------
    // FADE
    //-----------------------------------------------------------
    const targets = document.querySelectorAll('.fadein');
    if (!targets.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-show');
                observer.unobserve(entry.target); // 1回だけ
            }
        });
    }, {
        threshold: 0.2
    });

    targets.forEach(target => observer.observe(target));



    const targetSection = document.querySelector('.pg-content-estimate');
    const scrollChild = document.querySelector('.js-scroll-child');

    if (targetSection && scrollChild) {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    scrollChild.classList.add('is-hidden');
                } else {
                    scrollChild.classList.remove('is-hidden');
                }
            },
            {
                root: null,
                threshold: 0,
                rootMargin: '-50% 0px -50% 0px'
            }
        );

        observer.observe(targetSection);
    }


});



